import { SingleDateInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { DateTime } from 'luxon'
import React from 'react'
import { useTranslation } from 'react-i18next'

import FormFieldWrapper from 'components/FormField'
import { FormFieldInfoTooltip } from 'components/FormFieldInfoTooltip/FormFieldInfoTooltip'
import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'

export const MovingOutDateField = () => {
  const { t } = useTranslation(['common', 'terminateContract'])

  return (
    <Field name="movingOutDate">
      {({ field, meta, form }: FieldProps<FormValues['movingOutDate']>) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.movingOutDate')}
          className="mt-8"
          meta={meta}
          labelBold
          labelAddon={
            <FormFieldInfoTooltip
              text={t('terminateContract:texts.movingOutDateTooltip')}
            />
          }
        >
          <SingleDateInput
            {...field}
            value={field.value ?? ''}
            onChange={(value) => form.setFieldValue(field.name, value, true)}
            disabledBefore={DateTime.now().toJSDate()}
            disabledAfter={DateTime.fromFormat(
              form.values.endDate,
              'yyyy-MM-dd'
            ).toJSDate()}
            placeholder={t('common:placeholders.date')}
            datePickerPosition="bottomLeft"
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
